import React, { forwardRef } from 'react';
import { JourneyParams, Rate } from 'shared-types/Common';
import styled from 'styled-components';
import { RatesListing } from './RatesListing';
import { NoRatesAvailable } from '../NoRatesAvailable';
import { Spinner } from '@common/components';
import Alert from '@common/components/Alert/Alert';
import { RateCodeNotice } from '../hooks';

const Container = styled.div`
  position: relative;
  min-height: 220px;
`;

type RatesProps = {
  rates: Rate[];
  roomId: string;
  journeyParams: JourneyParams;
  fetching: boolean;
  roomIdsInBasket?: string[];
  notice?: RateCodeNotice;
};

const Rates = (
  { rates, roomId, journeyParams, fetching, roomIdsInBasket, notice }: RatesProps,
  ref
) => (
  <Container>
    {!fetching && (
      <>
        {notice && <Alert title={notice.title} content={notice.subtitle} />}
        {rates && rates.length > 0 && (
          <>
            <div ref={ref} />
            <RatesListing
              roomId={roomId}
              datePartyData={journeyParams}
              rates={rates}
              roomIdsInBasket={roomIdsInBasket}
            />
          </>
        )}
        {(!rates || !rates.length) && <NoRatesAvailable />}
      </>
    )}
    <Spinner isActive={fetching} showDelayMessage isLocal={true} />
  </Container>
);

export default forwardRef(Rates);
